import { isNumber } from '@src/utils/type-utils';

function getRootFontSize() {
  try {
    const rootFontSize = parseFloat(document.documentElement.style.fontSize.replace('px', ''));
    if (!isNumber(rootFontSize)) {
      throw new Error('获取rootFontSize失败');
    }
    return rootFontSize;
  } catch (e) {
    console.error(e);
    return 37.5;
  }
}

export default getRootFontSize;
